import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from './authentication.service';

/**
 * Logged in guard - protects of unauthorized user
 */
@Injectable()
export class LoggedInGuard implements CanActivate {
    /**
     * The "constructor"
     * @param {AuthenticationService} authenticationService
     */
    constructor(private authenticationService: AuthenticationService,
                private router: Router) {
    }

    /**
     * Implementation of CanActivate interface, check if user logged in, then init authenticationService.
     * If mock env, init mock method of authenticationService
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Promise<boolean>}
     */
    public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const isLoggedIn = this.authenticationService.isLoggedIn();
        if (!isLoggedIn) {
            this.router.navigate(['login']);
        }
        return isLoggedIn;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/security/logged-in.guard.ts